{
  "menu": {
    "title": "Trabajadores"
  },
  "title": "Trabajadores",
  "subtitle": "Quiénes marcan asistencia, en qué sedes y desde qué dispositivo.",
  "fields": {
    "firstNames": "Nombres",
    "lastNames": "Apellidos",
    "name": "Nombre completo",
    "document": "Documento",
    "documentType": "Tipo de documento",
    "documentNumber": "Número de documento",
    "phone": "Teléfono",
    "email": "Email",
    "internalCode": "Código interno",
    "primarySite": "Sede principal",
    "sites": "Sedes autorizadas",
    "status": "Estado",
    "device": "Dispositivo"
  },
  "status": {
    "ACTIVE": "Activo",
    "PENDING_ACTIVATION": "Pendiente",
    "INACTIVE": "Inactivo"
  },
  "documentType": {
    "DNI": "DNI",
    "CE": "CE",
    "PASSPORT": "Pasaporte",
    "OTHER": "Otro"
  },
  "platform": {
    "ios": "iPhone",
    "android": "Android",
    "desktop": "Escritorio",
    "other": "Otro",
    "none": "—"
  },
  "filters": {
    "search": "Buscar",
    "searchPlaceholder": "Nombre, apellido o documento",
    "site": "Sede",
    "siteAll": "Todas las sedes",
    "status": "Estado",
    "statusAll": "Todos los estados"
  },
  "actions": {
    "new": "Nuevo trabajador",
    "invite": "Generar invitación",
    "export": "Exportar CSV",
    "edit": "Editar",
    "changeSites": "Cambiar sedes"
  },
  "table": {
    "caption": "Trabajadores de la empresa",
    "actions": "Acciones",
    "document": "{type} {number}",
    "name": "{lastNames}, {firstNames}"
  },
  "empty": {
    "title": "Todavía no hay trabajadores",
    "description": "Registra a la primera persona para poder invitarla y que active Fermin en su teléfono.",
    "noSitesTitle": "Primero necesitas una sede activa",
    "noSitesDescription": "Un trabajador siempre pertenece a una o más sedes activas, con una de ellas como principal.",
    "noSitesAction": "Ir a Sedes"
  },
  "form": {
    "createTitle": "Nuevo trabajador",
    "editTitle": "Editar trabajador",
    "description": "Con estos datos el trabajador podrá activar Fermin en su teléfono.",
    "sitesLegend": "Sedes autorizadas",
    "sitesHelp": "Marca al menos una sede y elige cuál es la principal.",
    "primaryLabel": "Principal",
    "help": {
      "phone": "Entre 6 y 20 caracteres: dígitos, +, paréntesis, espacio o guion.",
      "email": "Opcional. Solo para avisos administrativos.",
      "internalCode": "Opcional. El código con el que ya identificas a esta persona."
    },
    "errors": {
      "firstNames": "Escribe los nombres (hasta 120 caracteres).",
      "lastNames": "Escribe los apellidos (hasta 120 caracteres).",
      "documentType": "Elige un tipo de documento.",
      "documentNumber": "El número de documento debe tener entre 4 y 32 caracteres.",
      "documentTaken": "Ya existe un trabajador con ese documento en tu empresa.",
      "phone": "Teléfono inválido: entre 6 y 20 caracteres (dígitos, +, paréntesis, espacio o guion).",
      "email": "Escribe un email válido o deja el campo vacío.",
      "internalCode": "El código interno puede tener hasta 40 caracteres.",
      "internalCodeTaken": "Ya existe un trabajador con ese código interno en tu empresa.",
      "sites": "Marca al menos una sede.",
      "primarySite": "Elige la sede principal.",
      "primarySiteNotSelected": "La sede principal debe estar entre las sedes marcadas."
    }
  },
  "invitation": {
    "title": "Enlace de invitación",
    "description": "Envíaselo a {name} por el canal que prefieras (WhatsApp, SMS o correo).",
    "warning": "Cópialo antes de cerrar: por seguridad no se volverá a mostrar.",
    "linkLabel": "Enlace de invitación",
    "expires": "Vence el {date}. Es de un solo uso.",
    "done": "Listo",
    "whatsapp": "Invitar por WhatsApp",
    "whatsappHelp": "Abre su chat en WhatsApp con el mensaje y el enlace listos: solo pulsa Enviar.",
    "whatsappNoPhone": "No tiene un celular válido: WhatsApp te dejará elegir el chat.",
    "whatsappMessage": "Hola {name}, te damos la bienvenida a Fermin, la app para marcar tu asistencia. Abre este enlace desde tu celular para activarla: {link}\n\nSi usas iPhone, ábrelo en Safari y agrega la app a tu pantalla de inicio antes de registrarte. El enlace es de un solo uso y vence el {date}.",
    "offerTitle": "Trabajador creado",
    "offerDescription": "«{name}» quedó pendiente de activación. Genera su invitación para que active Fermin en su teléfono.",
    "offerConfirm": "Generar invitación",
    "offerDismiss": "Ahora no",
    "cardTitle": "Invitación",
    "none": "Sin invitación generada",
    "noneHelp": "Genera una para que active Fermin en su teléfono.",
    "statusLabel": "Estado",
    "expiresAt": "Vence el",
    "new": "Generar nueva invitación",
    "inactiveNote": "Reactiva al trabajador para poder generar una invitación.",
    "status": {
      "PENDING": "Pendiente",
      "USED": "Usada",
      "EXPIRED": "Vencida",
      "REVOKED": "Revocada",
      "VERIFICATION_LOCKED": "Bloqueada"
    },
    "verificationLocked": "Se bloqueó tras 5 intentos fallidos de verificar los últimos 4 dígitos del documento. Si fue el trabajador, genera una nueva invitación; si no, revisa con quién se compartió el enlace.",
    "confirmSupersede": {
      "title": "¿Generar una invitación nueva?",
      "description": "{name} está activando su teléfono ahora mismo. Si generas una invitación nueva, la actual dejará de servir.",
      "confirm": "Generar de todos modos"
    }
  },
  "toast": {
    "created": "Trabajador creado",
    "updated": "Cambios guardados",
    "invited": "Invitación generada",
    "exported": "Descargamos {filename}",
    "exportError": "No pudimos generar el CSV. Inténtalo nuevamente.",
    "deviceRevoked": "Dispositivo revocado",
    "deactivated": "Trabajador desactivado",
    "reactivated": "Trabajador reactivado"
  },
  "detail": {
    "profileTitle": "Datos del trabajador",
    "sitesTitle": "Sedes autorizadas",
    "primaryTag": "Principal",
    "none": "—",
    "activatedAt": "Activo desde el {date}",
    "deactivatedAt": "Desactivado el {date}",
    "pendingActivation": "Todavía no activa Fermin en su teléfono.",
    "rebindTitle": "Solicitudes de re-vinculación",
    "rebindNone": "No tiene solicitudes pendientes.",
    "rebindOne": "Tiene 1 solicitud pendiente de aprobación.",
    "rebindMany": "Tiene {count} solicitudes pendientes de aprobación.",
    "rebindLink": "Ver solicitudes",
    "lastMarkTitle": "Última marcación",
    "attendanceTitle": "Estado actual",
    "comingSoon": "Disponible en la próxima versión."
  },
  "attendance": {
    "state": {
      "IN": "Dentro",
      "OUT": "Fuera",
      "UNRESOLVED": "Sin resolver"
    },
    "since": "Desde el {date}",
    "openShiftExceeded": "Turno abierto más tiempo del habitual",
    "none": "Todavía no tiene marcaciones.",
    "noneMark": "Sin marcaciones registradas.",
    "noPermission": "Necesitas el permiso de asistencia para ver este dato.",
    "lastMarkAt": "{type} el {date}"
  },
  "device": {
    "title": "Dispositivo",
    "none": "Sin dispositivo vinculado",
    "noneHelp": "Se vincula cuando el trabajador activa Fermin con una invitación.",
    "platform": "Plataforma",
    "system": "Sistema",
    "browser": "Navegador",
    "model": "Modelo",
    "unknown": "No identificado",
    "displayMode": "Modo de uso",
    "status": "Estado",
    "enrolledAt": "Enrolado el",
    "lastSeenAt": "Última actividad",
    "never": "Sin actividad registrada",
    "mode": {
      "standalone": "Aplicación instalada",
      "browser": "Navegador"
    },
    "statusLabel": {
      "ACTIVE": "Activo",
      "REVOKED": "Revocado"
    },
    "revoke": "Revocar dispositivo",
    "confirmTitle": "¿Revocar el dispositivo?",
    "confirmDescription": "«{name}» perderá el acceso de inmediato y verá la pantalla de dispositivo no registrado. Para volver a marcar necesitará una nueva invitación o que apruebes una solicitud de re-vinculación.",
    "reasonLabel": "Motivo (opcional)",
    "reasonHelp": "Queda registrado en la auditoría. Hasta 500 caracteres."
  },
  "deactivate": {
    "action": "Desactivar",
    "title": "¿Desactivar a {name}?",
    "description": "Dejará de poder marcar asistencia: revocamos su dispositivo, su sesión y sus invitaciones vigentes. Sus marcaciones históricas se conservan.",
    "reasonLabel": "Motivo (opcional)",
    "reasonHelp": "Queda registrado en la auditoría. Hasta 500 caracteres."
  },
  "reactivate": {
    "action": "Reactivar",
    "title": "¿Reactivar a {name}?",
    "description": "Volverá al estado Pendiente y necesitará una nueva invitación para activar Fermin en su teléfono.",
    "note": "El dispositivo revocado no se recupera: enrolará uno nuevo al activar la invitación."
  },
  "anonymized": {
    "title": "Datos personales eliminados",
    "description": "Este trabajador fue anonimizado el {date} por la política de privacidad de la empresa. Sus marcaciones se conservan con este identificador anónimo. Ya no se puede editar, cambiar de sedes, reactivar ni invitar."
  },
  "managed": {
    "notice": "Los datos con candado vienen del sistema integrado: se cambian allí y se actualizan al sincronizar. Invitar, revocar el dispositivo y re-vincular siguen en Fermin.",
    "scheduledTermination": "Cese programado: {date}"
  }
}
